// Google Analytics tracking utility
// GA4 Measurement ID for Negotiation Ninja AI

export const GA_MEASUREMENT_ID = 'G-7SDKPZKJGE';

// Initialize Google Analytics
export const initGA = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: window.location.pathname,
    });
  }
};

// Track page views
export const trackPageView = (url) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: url,
    });
  }
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track user sign-ups
export const trackSignUp = (method = 'google') => {
  trackEvent('sign_up', 'User', `Sign Up via ${method}`, null);
};

// Track user login
export const trackLogin = (method = 'google') => {
  trackEvent('login', 'User', `Login via ${method}`, null);
};

// Track subscription start (conversion)
export const trackSubscription = (plan, amount) => {
  if (typeof window !== 'undefined' && window.gtag) {
    // Track as purchase event for ecommerce
    window.gtag('event', 'purchase', {
      transaction_id: `txn_${Date.now()}`,
      value: amount,
      currency: 'GBP',
      items: [{
        item_id: plan,
        item_name: `${plan} Premium Subscription`,
        price: amount,
        quantity: 1
      }]
    });
    
    // Also track as custom conversion
    trackEvent('start_subscription', 'Monetization', plan, amount);
  }
};

// Track trial start
export const trackTrialStart = (plan) => {
  trackEvent('start_trial', 'Monetization', `${plan} Trial Started`, null);
};

// Track roleplay session start
export const trackRoleplayStart = (scenario) => {
  trackEvent('start_roleplay', 'Engagement', scenario, null);
};

// Track roleplay completion
export const trackRoleplayComplete = (scenario, score) => {
  trackEvent('complete_roleplay', 'Engagement', scenario, score);
};

// Track script generation
export const trackScriptGeneration = (scenarioType) => {
  trackEvent('generate_script', 'Engagement', scenarioType, null);
};

// Track challenge completion
export const trackChallengeComplete = (challengeId, amountSaved) => {
  trackEvent('complete_challenge', 'Engagement', challengeId, amountSaved);
};

// Track win logging
export const trackWinLog = (category, amountSaved) => {
  trackEvent('log_win', 'User Activity', category, amountSaved);
};

// Track feature engagement
export const trackFeatureUse = (featureName) => {
  trackEvent('use_feature', 'Feature Engagement', featureName, null);
};

// Track referral actions
export const trackReferral = (action) => {
  trackEvent('referral_action', 'Growth', action, null);
};

// Track revenue (for internal analytics)
export const trackRevenue = (amount, source) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: GA_MEASUREMENT_ID,
      value: amount,
      currency: 'GBP',
      transaction_id: `rev_${Date.now()}_${source}`
    });
  }
};

// Track user retention (returning user)
export const trackRetention = (daysSinceSignup) => {
  trackEvent('user_retention', 'Retention', `Day ${daysSinceSignup}`, daysSinceSignup);
};

// Track errors
export const trackError = (errorType, errorMessage) => {
  trackEvent('error', 'Error', errorType, null);
};

// Track onboarding completion
export const trackOnboardingComplete = (skillLevel) => {
  trackEvent('complete_onboarding', 'User', skillLevel, null);
};

// Track upgrade clicks (for conversion optimization)
export const trackUpgradeClick = (source) => {
  trackEvent('click_upgrade', 'Monetization', source, null);
};

export default {
  initGA,
  trackPageView,
  trackEvent,
  trackSignUp,
  trackLogin,
  trackSubscription,
  trackTrialStart,
  trackRoleplayStart,
  trackRoleplayComplete,
  trackScriptGeneration,
  trackChallengeComplete,
  trackWinLog,
  trackFeatureUse,
  trackReferral,
  trackRevenue,
  trackRetention,
  trackError,
  trackOnboardingComplete,
  trackUpgradeClick
};
